import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';

import Wrapper from './styled/Wrapper';
import Heading from './styled/Heading';
import Title from './styled/Title';
import Paragraph1 from './styled/Paragraph1';
import Paragraph2 from './styled/Paragraph2';
import EmailLink from './styled/EmailLink';
import ContentWrapper from './styled/ContentWrapper';
import Column1Wrapper from './styled/Column1Wrapper';
import Column2Wrapper from './styled/Column2Wrapper';

export default class ContactSection extends PureComponent {
  static defaultProps = {};

  static contextType = ThemeContext;

  onEmailClick = () => {
    // if(appState.analytics)appState.analytics._trackEvent('AboutPage', 'click email', 'office');
  };

  render() {
    const {
      className,
      heading,
      title,
      paragraph1,
      paragraph2,
      email,
      childRef,
    } = this.props;

    const p1 = paragraph1?.replace(/\n/g, '<br />') || '';
    const p2 = paragraph2?.replace(/\n/g, '<br />') || '';

    return (
      <Wrapper ref={childRef} className={className}>
        {heading && <Heading theme={this.context}>{heading}</Heading>}
        <Title theme={this.context}>{title}</Title>
        <ContentWrapper>
          <Column1Wrapper>
            <Paragraph1
              theme={this.context}
              dangerouslySetInnerHTML={{ __html: p1 }}
            />
            <EmailLink
              theme={this.context}
              label={email}
              link={`mailto:${email}`}
              target="_blank"
              onClick={this.onEmailClick}
            />
          </Column1Wrapper>
          <Column2Wrapper>
            <Paragraph2
              theme={this.context}
              dangerouslySetInnerHTML={{ __html: p2 }}
            />
          </Column2Wrapper>
        </ContentWrapper>
      </Wrapper>
    );
  }
}
